import { render, staticRenderFns } from "./ExportWizardNavItem.vue?vue&type=template&id=5cdb67a2&scoped=true&"
import script from "./ExportWizardNavItem.vue?vue&type=script&lang=js&"
export * from "./ExportWizardNavItem.vue?vue&type=script&lang=js&"
import style0 from "./ExportWizardNavItem.vue?vue&type=style&index=0&id=5cdb67a2&prod&scoped=true&lang=scss&"
import style1 from "./ExportWizardNavItem.vue?vue&type=style&index=1&id=5cdb67a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdb67a2",
  null
  
)

export default component.exports